import { render } from "./ub-cyber.vue?vue&type=template&id=54df23ca&scoped=true"
import script from "./ub-cyber.vue?vue&type=script&lang=js"
export * from "./ub-cyber.vue?vue&type=script&lang=js"

import "./ub-cyber.vue?vue&type=style&index=0&id=54df23ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54df23ca"]])

export default __exports__